import React, { useContext } from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { SimpleContext } from "../../../../../../store/context/simple-context";
import { getTrueClasses } from "../../../../../../helpers";
import Checkbox from "./Checkbox";
import "./index.scss";

const Payment = ({ optionName, price, cents, period, discount, youTubeId }) => {
  const {
    translate: { t },
    update: { openYouTube },
  } = useContext(SimpleContext);

  return (
    <div
      className={getTrueClasses(
        "GP-C-O-O-P",
        period === "/one-time" && "GP-C-O-O-P_ot"
      )}
    >
      <div className="GP-C-O-O-P-switch">
        <div className="GP-C-O-O-P__priceBlock">
          <p className="GP-C-O-O-P__price">
            {`$${price}`}
            {cents && <sup>{cents}</sup>}
            <span>{t(period)}</span>
          </p>
          {discount && (
            <p className="GP-C-O-O-P__discount">
              <strike>{`$${discount}`}</strike>
              {t(period)}
            </p>
          )}
        </div>
        <Checkbox optionName={optionName} />
      </div>
      <div
        className="GP-C-O-O-P__btn"
        onClick={() => {
          openYouTube(youTubeId);
        }}
      >
        {parse(t("Watch Demo"))}
      </div>
    </div>
  );
};
Payment.propTypes = {
  optionName: PropTypes.string.isRequired,
  price: PropTypes.number,
  cents: PropTypes.number,
  period: PropTypes.string,
  discount: PropTypes.number,
  youTubeId: PropTypes.string,
};

export default Payment;
